// src/firebase.js
import { initializeApp }   from 'firebase/app';
import { getAuth }         from 'firebase/auth';
import { getFirestore }    from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAXLAX1P8WBQw7k9CefOOLWYZHvnSc4jIU",
    authDomain: "kivotos-outreach.firebaseapp.com",
    projectId: "kivotos-outreach",
    storageBucket: "kivotos-outreach.firebasestorage.app",
    messagingSenderId: "714462950280",
    appId: "1:714462950280:web:70f3ec5c09224a4342403d",
    measurementId: "G-SZW90EBND0"
  };

const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db   = getFirestore(app);
